import React from "react";

const TermsOfService = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 px-4">
      <div className="max-w-3xl bg-white shadow-lg rounded-lg p-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Terms of Service
        </h1>
        <p className="text-gray-700 mb-4">
          By using our services, you agree to the following terms and
          conditions.
        </p>

        <h2 className="text-xl font-semibold text-gray-800 mt-6">
          Usage Policy
        </h2>
        <p className="text-gray-600">
          Our services are intended for authentication and email verification
          purposes only.
        </p>

        <h2 className="text-xl font-semibold text-gray-800 mt-6">
          Restrictions
        </h2>
        <p className="text-gray-600">
          You must not misuse our services, attempt unauthorized access, or
          engage in activities that violate laws.
        </p>

        <h2 className="text-xl font-semibold text-gray-800 mt-6">Contact Us</h2>
        <p className="text-gray-600">
          If you have any concerns, reach out to us at{" "}
          <a
            href="mailto:support@quangphuly.online"
            className="text-blue-600 hover:underline"
          >
            support@quangphuly.online
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default TermsOfService;
